var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_42)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2_42)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    rx: 250,
    fill: "#BBC2FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395,
    cy: 177,
    r: 307,
    transform: "rotate(-90 395 177)",
    fill: "#887EF2",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 443,
    cy: 148,
    r: 250,
    transform: "rotate(-90 443 148)",
    fill: "#887EF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.781 316.662L261.802 352.517C264.012 354.782 266.775 356.431 269.818 357.301C272.861 358.17 276.078 358.23 279.151 357.474C282.244 356.755 285.099 355.253 287.443 353.112C289.787 350.97 291.54 348.262 292.535 345.247L351.688 167.953C352.923 164.631 353.178 161.024 352.422 157.562C351.667 154.099 349.933 150.926 347.427 148.42C344.921 145.914 341.748 144.181 338.286 143.425C334.823 142.67 331.217 142.925 327.895 144.159L150.6 203.312C147.482 204.378 144.704 206.256 142.554 208.755C140.405 211.253 138.961 214.28 138.373 217.522C137.766 220.472 137.901 223.525 138.767 226.41C139.632 229.294 141.2 231.918 143.33 234.046L188.604 279.319L187.117 336.655L225.781 316.662Z",
    fill: "white",
    stroke: "#5C5C5C",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.401 147.795L188.604 279.32",
    stroke: "#5C5C5C",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_42"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2_42"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    rx: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpIcon);
export default __webpack_public_path__ + "static/media/LP_Icon.28bae40cb7d6bbea7598b81d660be319.svg";
export { ForwardRef as ReactComponent };